$(document).ready(function(){
  // 中身が無い欄はブロックごと消す。
  // 外枠は2種類ある: 開閉ありは .product__accordion、開閉なしの常時表示は .product__static-tab。
  // 判定は html() ではなく text() で行う。メタフィールド未登録の欄は
  // 空の <div></div> だけが残ることがあり、html() では「空」と判定できないため。
  // ただしテキストが無くても画像・表・埋め込みがあれば中身ありとみなす。
  var BLOCK_SELECTOR = '.product__accordion, .product__static-tab';

  function isEmptyContent(el){
    var $el = $(el);
    if ($el.find('img, picture, table, iframe, video').length > 0) return false;
    return $el.text().trim() == "";
  }

  $('.product__accordion .accordion__content, .product__static-tab .accordion__content').each(function(){
    if (isEmptyContent(this)) {
      $(this).closest(BLOCK_SELECTOR).remove();
    }
  });
});

function isInViewport(ele) {
  var elementTop = ele.offsetTop;
  var elementBottom = elementTop + ele.offsetHeight / 2;
  var viewportTop = window.pageYOffset || document.documentElement.scrollTop;
  var viewportHalf = viewportTop + (window.innerHeight || document.documentElement.clientHeight) / 2;
  return elementBottom > viewportTop && elementTop < viewportHalf;
}

document.addEventListener('DOMContentLoaded', function(){
  const prodForm = document.querySelector('product-form.product-form')
  const prodMedia = document.querySelector('slider-component.thumbnail-slider')
  const prodMediaMain = document.querySelector('variant-radios')
  const prodMediaWrapper = document.querySelector('.product__media-wrapper')
  const stickyATC = () => {
                if (!isInViewport(prodForm)){
        prodForm.classList.add('sticky_atc')
      }
    // if (isInViewport(prodMedia)){
    //   prodForm.classList.remove('sticky_atc')
    // }
    // #blocked out by Sean to fix 1 image product case
        if (isInViewport(prodMediaWrapper)){
      prodForm.classList.remove('sticky_atc')
    }
    if (isInViewport(prodMediaMain)){
      prodForm.classList.remove('sticky_atc')
    } 

    
    
  }
  
  if (window.matchMedia("(max-width: 767.9px)").matches){

    stickyATC() 
  }
  
  window.addEventListener('scroll', function(){
    if (window.matchMedia("(max-width: 767.9px)").matches){
      stickyATC()
    }
  })
})